import { ReactNode } from 'react';
import { EmployeeLabels } from '@/api/apis/case';
import { ChipWithStatusProps } from '../ChipWithStatus/ChipWithStatus';

export enum ResourceAvatarStatusChipType {
  OpoUser = 'opoUser',
  OpoContact = 'opoContact',
}

export type ResourceAvatarStatusChip = {
  type: ResourceAvatarStatusChipType;
};

type AvatarChipConfig = {
  color: ChipWithStatusProps['color'];
  variant: ChipWithStatusProps['variant'];
  content: ReactNode;
  className: string;
  hasBottomMargin: boolean;
};

const OPO_CHIP_CONFIG: Record<ResourceAvatarStatusChipType, AvatarChipConfig> = {
  [ResourceAvatarStatusChipType.OpoUser]: {
    color: 'success',
    variant: 'solid',
    content: <span className="block w-full text-center">User</span>,
    className: 'absolute bottom-[-8px] min-w-[48px]',
    hasBottomMargin: false,
  },
  [ResourceAvatarStatusChipType.OpoContact]: {
    color: 'default',
    variant: 'solid',
    content: <span className="block w-full text-center">Contact</span>,
    className: 'absolute bottom-[-8px] min-w-[48px]',
    hasBottomMargin: false,
  },
};

export const getAvatarChipConfig = ({
  chipProps,
  isPrimary,
  label,
  statusChip,
  children,
}: {
  chipProps?: ChipWithStatusProps;
  isPrimary?: boolean;
  label?: EmployeeLabels;
  statusChip?: ResourceAvatarStatusChip;
  children: ReactNode;
}): AvatarChipConfig | null => {
  if (statusChip) {
    return OPO_CHIP_CONFIG[statusChip.type];
  }

  if (isPrimary || label === EmployeeLabels.Primary) {
    return {
      color: 'success',
      variant: 'solid',
      content: children,
      className: 'absolute bottom-[-5px]',
      hasBottomMargin: true,
    };
  }

  if (label) {
    return {
      color: 'secondary',
      variant: 'solid',
      content: children,
      className: 'absolute bottom-[-5px]',
      hasBottomMargin: true,
    };
  }

  if (chipProps?.status) {
    return {
      color: 'secondary',
      variant: 'dot',
      content: children,
      className: '',
      hasBottomMargin: false,
    };
  }

  return null;
};
